goog.provide("shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_arrows_outward_svg$default");
shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_arrows_outward_svg$default = shadow.js.shim.module$src$svg$shapes$rectangle$rectangle_arrows_outward_svg.default;
